import { Park, Resort } from "../types";
import {
  ALICEINWONDERLAND,
  ALIENPIZZAPLANET,
  ASTROBLASTERS,
  AUTOPIA,
  AVENGERSHQ,
  BIGTHUNDERMOUNTAIN,
  CASEYJRCIRCUSTRAIN,
  CHIPNDALESGADGETCOASTER,
  DAVYCROCKETTSCANOESRIDE,
  DONALDSDUCKPOND,
  DUMBOTHEFLYINGELEPHANT,
  ENCHANTEDTIKIROOM,
  FINDINGNEMO,
  GOLDENZEPHYR,
  GOOFYSHOWTOYARD,
  GOOFYSSKYSCHOOL,
  GUARDIANSOFTHEGALAXY,
  HAUNTEDMANSIONRIDE,
  INCREDICOASTER,
  INDIANAJONESRIDE,
  INSIDEOUTEMOTIONALWHIRLWIND,
  ITSASMALLWORLD,
  JESSIESCRITTERCAROUSEL,
  JUMPINJELLYFISH,
  JUNGLECRUISERIDE,
  KINGARTHURCAROUSEL,
  LUIGISROLICKINROADSTERS,
  MADTEAPARTY,
  MATERSJUNKYARDJAMBOREE,
  MATTERHORNBOBSLEDS,
  MICKEYMINNIERUNAWAYRAILWAY,
  MONSTERSINC,
  MRTOADSWILDRIDE,
  PETERPANRIDE,
  PINOCCHIORIDE,
  PIRATESLAIR,
  PIRATESOFTHECARIBBEANRIDE,
  PIXARPALAROUND,
  PIXIEHOLLOW,
  PYMSTESTKITCHEN,
  RADIATORSPRINGSRACERS,
  RISEOFTHERESISTANCE,
  ROGERRABBITSCARTOONSPIN,
  SANFRANSOKYOSQUARE,
  SILLYSYMPHONY,
  SLEEPINGBEAUTYCASTLEWALKTHROUGH,
  SMUGGLERSRUN,
  SNOWWHITE,
  SPACEMOUNTAIN,
  STARTOURS,
  STORYBOOKLANDCANALBOATS,
  THELITTLEMERMAID,
  TIANASPLASHMOUNTAIN,
  TOYSTORYMIDWAYMANIA,
  TURTLETALK,
  WEBSLINGERS,
  WINNIETHEPOOH,
} from "./dl-rides";
import {
  MK_SPACEMOUNTAIN,
  MK_TRONLIGHTCYCLERUN,
  MK_BIGTHUNDERMOUNTAIN,
  MK_SEVENDWARFSMINETRAIN,
  MK_HAUNTEDMANSION,
  MK_PIRATESOFTHECARIBBEAN,
  MK_JUNGLECRUISE,
  MK_TIANASBAYOUADVENTURE,
  MK_PETERPANSFLIGHT,
  MK_ITSASMALLWORLD,
  MK_BUZZLIGHTYEAR,
  MK_WINNIETHEPOOH,
  MK_UNDERTHESEA,
  MK_BARNSTORMER,
  MK_DUMBO,
  MK_MADTEAPARTY,
  MK_PRINCECHARMINGREGALCARROUSEL,
  MK_TOMORROWLANDSPEEDWAY,
  MK_ASTROORBITER,
  MK_MAGICCARPETSOFALADDIN,
  MK_SWISSFAMILYTREEHOUSE,
  MK_CAROUSELOFPROGRESS,
  MK_PEOPLEMOVER,
  MK_COUNTRYBEARJAMBOREE,
  MK_HALLOFPRESIDENTS,
  MK_PHILHARMAGIC,
  MK_MONSTERSINCLAUGHFLOOR,
  MK_TOMSAWYERISLAND,
  MK_LIBERTYBELLERIVERBOAT,
  EP_SPACESHIPEARTH,
  EP_TESTTRACK,
  EP_FROZENEVERAFTER,
  EP_REMYSRATATOUILLEADVENTURE,
  EP_COSMICREWIND,
  EP_SOARIN,
  EP_LIVINGWITHTHELAND,
  EP_SEASWITHNEMO,
  EP_JOURNEYOFWATER,
  EP_GRANFIESTATOUR,
  EP_MISSIONSPACE,
  EP_TURTLETALK,
  HS_RISEOFTHERESISTANCE,
  HS_SMUGGLERSRUN,
  HS_TOWEROFTERROR,
  HS_ROCKNROLLERCOASTER,
  HS_SLINKYDOGDASH,
  HS_TOYSTORYMANIA,
  HS_MICKEYMINNIERUNAWAY,
  HS_ALIENSWIRLING,
  HS_STARTOURS,
  HS_MUPPETVISION,
  AK_FLIGHTOFPASSAGE,
  AK_NAVIRIVERJOURNEY,
  AK_EXPEDITIONEVEREST,
  AK_KILIMANJAROSAFARIS,
  AK_DINOSAUR,
  AK_KALIRIVERRAPIDS,
  AK_TRICERATOPSPIN,
  AK_ITSTOUGHTOBEABUG,
} from "./wdw-rides";

export const DISNEYLANDPARKS: Park[] = [
  {
    title: "Disneyland",
    description: "The original park",
    logo: "https://upload.wikimedia.org/wikipedia/commons/1/13/Disneyland_Park_Logo.svg",
    color: "#FF0000",
    background:
      "https://en.wikipedia.org/wiki/Disneyland#/media/File:Sleeping_Beauty_Castle_2019.jpg",
    map: {
      image:
        "https://en.wikipedia.org/wiki/Disneyland#/media/File:Disneyland_Park_Logo.svg",
      dimensions: [1000, 1000],
    },
    rides: [
      PETERPANRIDE,
      JUNGLECRUISERIDE,
      INDIANAJONESRIDE,
      PIRATESOFTHECARIBBEANRIDE,
      PIRATESLAIR,
      HAUNTEDMANSIONRIDE,
      DAVYCROCKETTSCANOESRIDE,
      WINNIETHEPOOH,
      TIANASPLASHMOUNTAIN,
      BIGTHUNDERMOUNTAIN,
      MICKEYMINNIERUNAWAYRAILWAY,
      ROGERRABBITSCARTOONSPIN,
      CHIPNDALESGADGETCOASTER,
      MRTOADSWILDRIDE,
      PINOCCHIORIDE,
      PIXIEHOLLOW,
      SNOWWHITE,
      STORYBOOKLANDCANALBOATS,
      DUMBOTHEFLYINGELEPHANT,
      CASEYJRCIRCUSTRAIN,
      ALICEINWONDERLAND,
      MATTERHORNBOBSLEDS,
      KINGARTHURCAROUSEL,
      MADTEAPARTY,
      SLEEPINGBEAUTYCASTLEWALKTHROUGH,
      STARTOURS,
      ASTROBLASTERS,
      FINDINGNEMO,
      SMUGGLERSRUN,
      RISEOFTHERESISTANCE,
      ENCHANTEDTIKIROOM,
      ITSASMALLWORLD,
      GOOFYSHOWTOYARD,
      DONALDSDUCKPOND,
      AUTOPIA,
      ALIENPIZZAPLANET,
      SPACEMOUNTAIN,
    ],
    center: [33.81209, -117.91895],
  },
  {
    title: "Disneyland California Adventure",
    description: "The newer park",
    logo: "https://upload.wikimedia.org/wikipedia/en/1/13/Disney_california_adventure_logo.svg",
    color: "#0000FF",
    background:
      "https://en.wikipedia.org/wiki/Disney_California_Adventure#/media/File:Pixarpiersunset2019_(cropped)_(cropped).jpg",
    map: {
      image:
        "https://en.wikipedia.org/wiki/Disney_California_Adventure#/media/File:Disney_california_adventure_logo.svg",
      dimensions: [1000, 1000],
    },
    rides: [
      MONSTERSINC,
      TURTLETALK,
      GUARDIANSOFTHEGALAXY,
      INCREDICOASTER,
      LUIGISROLICKINROADSTERS,
      MATERSJUNKYARDJAMBOREE,
      RADIATORSPRINGSRACERS,
      JESSIESCRITTERCAROUSEL,
      INSIDEOUTEMOTIONALWHIRLWIND,
      PIXARPALAROUND,
      TOYSTORYMIDWAYMANIA,
      GOLDENZEPHYR,
      GOOFYSSKYSCHOOL,
      JUMPINJELLYFISH,
      THELITTLEMERMAID,
      SILLYSYMPHONY,
      WEBSLINGERS,
      PYMSTESTKITCHEN,
      AVENGERSHQ,
      SANFRANSOKYOSQUARE,
    ],
    center: [33.806439962074585, -117.9196071624756],
  },
];

export const DISNEYWORLDPARKS: Park[] = [
  {
    title: "Magic Kingdom",
    description: "The most magical place on Earth",
    logo: "https://upload.wikimedia.org/wikipedia/en/6/6b/Magic_Kingdom_Logo.svg",
    color: "#1A3C7A",
    background: "",
    map: { image: "", dimensions: [1000, 1000] },
    rides: [
      MK_SPACEMOUNTAIN,
      MK_TRONLIGHTCYCLERUN,
      MK_BIGTHUNDERMOUNTAIN,
      MK_SEVENDWARFSMINETRAIN,
      MK_HAUNTEDMANSION,
      MK_PIRATESOFTHECARIBBEAN,
      MK_JUNGLECRUISE,
      MK_TIANASBAYOUADVENTURE,
      MK_PETERPANSFLIGHT,
      MK_ITSASMALLWORLD,
      MK_BUZZLIGHTYEAR,
      MK_WINNIETHEPOOH,
      MK_UNDERTHESEA,
      MK_BARNSTORMER,
      MK_DUMBO,
      MK_MADTEAPARTY,
      MK_PRINCECHARMINGREGALCARROUSEL,
      MK_TOMORROWLANDSPEEDWAY,
      MK_ASTROORBITER,
      MK_MAGICCARPETSOFALADDIN,
      MK_SWISSFAMILYTREEHOUSE,
      MK_CAROUSELOFPROGRESS,
      MK_PEOPLEMOVER,
      MK_COUNTRYBEARJAMBOREE,
      MK_HALLOFPRESIDENTS,
      MK_PHILHARMAGIC,
      MK_MONSTERSINCLAUGHFLOOR,
      MK_TOMSAWYERISLAND,
      MK_LIBERTYBELLERIVERBOAT,
    ],
    center: [28.4177, -81.5812],
  },
  {
    title: "EPCOT",
    description: "Every Person Comes Out Tired",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Epcot_Logo.svg",
    color: "#7B2D8E",
    background: "",
    map: { image: "", dimensions: [1000, 1000] },
    rides: [
      EP_SPACESHIPEARTH,
      EP_TESTTRACK,
      EP_FROZENEVERAFTER,
      EP_REMYSRATATOUILLEADVENTURE,
      EP_COSMICREWIND,
      EP_SOARIN,
      EP_LIVINGWITHTHELAND,
      EP_SEASWITHNEMO,
      EP_JOURNEYOFWATER,
      EP_GRANFIESTATOUR,
      EP_MISSIONSPACE,
      EP_TURTLETALK,
    ],
    center: [28.3747, -81.5494],
  },
  {
    title: "Hollywood Studios",
    description: "Lights, camera, action!",
    logo: "https://upload.wikimedia.org/wikipedia/en/f/f5/Disney%27s_Hollywood_Studios_2019.svg",
    color: "#C4953A",
    background: "",
    map: { image: "", dimensions: [1000, 1000] },
    rides: [
      HS_RISEOFTHERESISTANCE,
      HS_SMUGGLERSRUN,
      HS_TOWEROFTERROR,
      HS_ROCKNROLLERCOASTER,
      HS_SLINKYDOGDASH,
      HS_TOYSTORYMANIA,
      HS_MICKEYMINNIERUNAWAY,
      HS_ALIENSWIRLING,
      HS_STARTOURS,
      HS_MUPPETVISION,
    ],
    center: [28.3575, -81.5583],
  },
  {
    title: "Animal Kingdom",
    description: "Nahtazu",
    logo: "https://upload.wikimedia.org/wikipedia/en/7/70/Disney%27s_Animal_Kingdom_Logo.svg",
    color: "#2D6B3F",
    background: "",
    map: { image: "", dimensions: [1000, 1000] },
    rides: [
      AK_FLIGHTOFPASSAGE,
      AK_NAVIRIVERJOURNEY,
      AK_EXPEDITIONEVEREST,
      AK_KILIMANJAROSAFARIS,
      AK_DINOSAUR,
      AK_KALIRIVERRAPIDS,
      AK_TRICERATOPSPIN,
      AK_ITSTOUGHTOBEABUG,
    ],
    center: [28.3553, -81.5901],
  },
];

export const RESORTS: Record<string, Resort> = {
  disneyland: {
    title: "Disneyland Resort",
    description: "The original park",
    logo: "https://en.wikipedia.org/wiki/Disneyland#/media/File:Disneyland_Park_Logo.svg",
    color: "#FF0000",
    background:
      "https://en.wikipedia.org/wiki/Disneyland#/media/File:Sleeping_Beauty_Castle_2019.jpg",
    parks: DISNEYLANDPARKS,
  },
  disneyworld: {
    title: "Walt Disney World",
    description: "The most magical place on Earth",
    logo: "",
    color: "#1A3C7A",
    background: "",
    parks: DISNEYWORLDPARKS,
  },
};
